import styled from 'styled-components';
import { IPOStyleCommon, IPOStyleMixins } from '../../../styles';

export const MemberCardWrap = styled.div<{ isMyTeam: boolean }>`
	position: relative;
	width: 244px;
	height: ${prop => (prop.isMyTeam ? '218px' : '160px')};
	padding: 10px 28px 5px 14px;

	.content {
		position: relative;
		z-index: 9;
		height: 100%;
		width: 100%;
		${IPOStyleMixins.flex('row', 'space-between', 'flex-start')};

		> .left {
			font-size: 12px;
			width: 100%;
			> .avatar-wrap{
				${IPOStyleMixins.flex('row', 'space-between', '')};

			}
			.primary-name {
				color: ${IPOStyleCommon.IPOColors.text.textImportant};
				font-size: 16px;
				font-weight: 500;
			}

			.inferior-name {
				color: ${IPOStyleCommon.IPOColors.text.textSlight};
				margin-bottom: 12px;
			}

			.flex-row {
				${IPOStyleMixins.flex('row', 'flex-start', 'center')};
				word-break: keep-all;
				margin-top: 5px;
				> .ipo-label {
					color: ${IPOStyleCommon.IPOColors.text.textNote};
				}

				> .info {
					color: ${IPOStyleCommon.IPOColors.text.textSlight};
					${IPOStyleMixins.flex('row', 'flex-start', 'center')};

					& .ant-avatar {
						margin-left: 0;
						width: 22px;
						height: 22px;
						line-height: 22px;
					}
					> .ant-avatar-group {
						> .ant-avatar {
							cursor: pointer;
							::before {
								content: '...';
								font-size: 14px;
								text-align: center;
								line-height: 14px;
								width: 100%;
							}
							.ant-avatar-string {
								display: none;
							}
						}
					}
				}
			}
			.flex-row-team {
				margin-top: 10px;
			}

			.activa-state {
				color: #f85151;
				font-size: 12px;
				margin-left: 6px;
			}
		}

		> .right {
			height: 100%;
			padding-top: 6px;
			padding-bottom: ${prop => (prop.isMyTeam ? '6px' : '0px')};
			${IPOStyleMixins.flex('column', 'space-between', 'flex-end')};
		}
	}

	img.member-bg-img {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 5;
	}
`;
